import { Box, Collapse, Typography } from "@mui/material";
import { useSyndeticsConfig } from "@tlc/ls2pac/components/SyndeticsConfig";
import {
  LibraryThingEnrichment,
  LibraryThingMetaData,
} from "@tlc/syndetics-util";
import React, { useEffect, useState } from "react";
import { ResourceDWR } from "../../../../dto/ResourceDWR";
import {
  getISBNList,
  getUPCList,
} from "@tlc/ls2pac/app/utils/PACStandardNumberUtil";
import { useLanguage } from "@tlc/ls2pac/components/Language";

interface SyndeticsSummaryProps {
  resource: ResourceDWR;
}
export const SyndeticsSummary = ({ resource }: SyndeticsSummaryProps) => {
  const { translate } = useLanguage();
  const { syndeticsConfig, hasSummaryEnrichment, util } = useSyndeticsConfig();
  const id = `resource_${resource.id}_summary`;
  const [expanded, setExpanded] = useState<boolean>(false);
  useEffect(() => {
    const refreshMetaData = async () => {
      var isbn = getISBNList(resource.standardNumbers);
      var upc = getUPCList(resource.standardNumbers);
      const metaData: LibraryThingMetaData = {
        unbound_containing_selector: `#${id}`,
        title: resource.shortTitle,
        author: resource.shortAuthor,
        isbn: isbn,
        upc: upc,
        usemegadiv: false,
        branchFilters: syndeticsConfig.branchFilters,
      };
      try {
        const { errors, enrichmentsShown } = await util.refreshMetaData(
          metaData
        );
        if (enrichmentsShown.includes(LibraryThingEnrichment.Summary)) {
          setExpanded(true);
        }
      } catch (e: unknown) {
        console.error(e);
      }
    };
    if (
      util &&
      syndeticsConfig?.active &&
      hasSummaryEnrichment &&
      resource?.id
    ) {
      refreshMetaData();
    }
  }, [util, hasSummaryEnrichment, syndeticsConfig?.active, resource?.id]);

  if (!syndeticsConfig?.active || !hasSummaryEnrichment) {
    return null;
  }

  return (
    <Collapse id={id} in={expanded} timeout="auto">
      {/* Important: do not use unmountOnExit */}
      <Typography variant="h6" component={"h4"}>
        {translate("summary")}
      </Typography>
      <Box className="unbound_summary"></Box>
    </Collapse>
  );
};
